import VerticalStepper from '../../../../../../components/VerticalStepper/VerticalStepper';
import { transformLogisticServiceHistoryToStepperSteps } from '../utils/logisticServiceHistoryStepper.utils';
import { ILogisticServiceHistory, TLogisticServiceStatusName } from '../../../../../../types/suscription/history.types';

interface ILogisticServiceHistoryStepperProps {
  logisticServiceHistory: ILogisticServiceHistory[];
  logisticServiceStatusName: TLogisticServiceStatusName;
}

export const LogisticServiceHistoryStepper = ({
  logisticServiceHistory,
  logisticServiceStatusName
}: ILogisticServiceHistoryStepperProps) => {
  const steps = transformLogisticServiceHistoryToStepperSteps(logisticServiceHistory, logisticServiceStatusName);

  return <VerticalStepper steps={steps} />;
};
